import { supabase } from './supabaseClient';

// Helper functions pour Supabase

// MEMBRES
export const syncMembres = {
  add: async (membre) => {
    const { data, error } = await supabase
      .from('membres')
      .insert([membre])
      .select()
      .single();
    if (error) throw error;
    return data;
  },
  
  update: async (id, updates) => {
    const { data, error } = await supabase
      .from('membres')
      .update(updates)
      .eq('id', id)
      .select()
      .single();
    if (error) throw error;
    return data;
  },
  
  delete: async (id) => {
    const { error } = await supabase
      .from('membres')
      .delete()
      .eq('id', id);
    if (error) throw error;
  }
};

// DÉPENSES
export const syncDepenses = {
  add: async (depense) => {
    const { data, error } = await supabase
      .from('depenses')
      .insert([depense])
      .select()
      .single();
    if (error) throw error;
    return data;
  },
  
  update: async (id, updates) => {
    const { data, error } = await supabase
      .from('depenses')
      .update(updates)
      .eq('id', id)
      .select()
      .single();
    if (error) throw error;
    return data;
  },
  
  delete: async (id) => {
    const { error } = await supabase
      .from('depenses')
      .delete()
      .eq('id', id);
    if (error) throw error;
  }
};

// ENTRÉES
export const syncEntrees = {
  add: async (entree) => {
    const { data, error } = await supabase
      .from('entrees')
      .insert([entree])
      .select()
      .single();
    if (error) throw error;
    return data;
  },
  
  update: async (id, updates) => {
    const { data, error } = await supabase
      .from('entrees')
      .update(updates)
      .eq('id', id)
      .select()
      .single();
    if (error) throw error;
    return data;
  },
  
  delete: async (id) => {
    const { error } = await supabase
      .from('entrees')
      .delete()
      .eq('id', id);
    if (error) throw error;
  }
};

// EMPLOYÉS
export const syncEmployes = {
  add: async (employe) => {
    const { data, error } = await supabase
      .from('employes')
      .insert([employe])
      .select()
      .single();
    if (error) throw error;
    return data;
  },
  
  delete: async (id) => {
    const { error } = await supabase
      .from('employes')
      .delete()
      .eq('id', id);
    if (error) throw error;
  }
};

// FACTURES
export const syncFactures = {
  add: async (facture) => {
    const { data, error } = await supabase
      .from('factures')
      .insert([facture])
      .select()
      .single();
    if (error) throw error;
    return data;
  },
  
  delete: async (id) => {
    const { error } = await supabase
      .from('factures')
      .delete()
      .eq('id', id);
    if (error) throw error;
  }
};

// SALAIRES
export const syncSalaires = {
  add: async (salaire) => {
    const { data, error } = await supabase
      .from('salaires')
      .insert([salaire])
      .select()
      .single();
    if (error) throw error;
    return data;
  },
  
  delete: async (id) => {
    const { error } = await supabase
      .from('salaires')
      .delete()
      .eq('id', id);
    if (error) throw error;
  }
};

// CRÉDITS
export const syncCredits = {
  add: async (credit) => {
    const { data, error } = await supabase
      .from('credits')
      .insert([credit])
      .select()
      .single();
    if (error) throw error;
    return data;
  },
  
  update: async (id, updates) => {
    const { data, error } = await supabase
      .from('credits')
      .update(updates)
      .eq('id', id)
      .select()
      .single();
    if (error) throw error;
    return data;
  },
  
  delete: async (id) => {
    const { error } = await supabase
      .from('credits')
      .delete()
      .eq('id', id);
    if (error) throw error;
  }
};

// REMBOURSEMENTS CRÉDITS
export const syncRemboursementsCredits = {
  add: async (remboursement) => {
    const { data, error } = await supabase
      .from('remboursements_credits')
      .insert([remboursement])
      .select()
      .single();
    if (error) throw error;
    return data;
  },
  
  delete: async (id) => {
    const { error } = await supabase
      .from('remboursements_credits')
      .delete()
      .eq('id', id);
    if (error) throw error;
  }
};

// DÉPENSES RÉCURRENTES
export const syncDepensesRecurrentes = {
  add: async (depenseRecurrente) => {
    const { data, error } = await supabase
      .from('depenses_recurrentes')
      .insert([depenseRecurrente])
      .select()
      .single();
    if (error) throw error;
    return data;
  },
  
  update: async (id, updates) => {
    const { data, error } = await supabase
      .from('depenses_recurrentes')
      .update(updates)
      .eq('id', id)
      .select()
      .single();
    if (error) throw error;
    return data;
  },
  
  delete: async (id) => {
    const { error } = await supabase
      .from('depenses_recurrentes')
      .delete()
      .eq('id', id);
    if (error) throw error;
  }
};

// CLIENTS BELGES
export const syncClientsBelges = {
  add: async (client) => {
    const { data, error } = await supabase
      .from('clients_belges')
      .insert([client])
      .select()
      .single();
    if (error) throw error;
    return data;
  },
  
  delete: async (id) => {
    const { error } = await supabase
      .from('clients_belges')
      .delete()
      .eq('id', id);
    if (error) throw error;
  }
};

// PRODUITS BELGES
export const syncProduitsBelges = {
  add: async (produit) => {
    const { data, error } = await supabase
      .from('produits_belges')
      .insert([produit])
      .select()
      .single();
    if (error) throw error;
    return data;
  },
  
  delete: async (id) => {
    const { error } = await supabase
      .from('produits_belges')
      .delete()
      .eq('id', id);
    if (error) throw error;
  }
};

// FACTURES BELGES
export const syncFacturesBelges = {
  add: async (facture) => {
    const { data, error } = await supabase
      .from('factures_belges')
      .insert([facture])
      .select()
      .single();
    if (error) throw error;
    return data;
  },
  
  delete: async (id) => {
    const { error } = await supabase
      .from('factures_belges')
      .delete()
      .eq('id', id);
    if (error) throw error;
  }
};

// Fonction pour migrer les données locales vers Supabase
export const migrateLocalDataToSupabase = async () => {
  const savedData = localStorage.getItem('monarchTradeGroup');
  if (!savedData) return;
  
  try {
    const data = JSON.parse(savedData);
    const results = {
      success: 0,
      errors: []
    };
    
    // Migrer les membres
    if (data.membres && data.membres.length > 0) {
      for (const membre of data.membres) {
        try {
          await syncMembres.add(membre);
          results.success++;
        } catch (error) {
          results.errors.push({ type: 'membre', item: membre, error });
        }
      }
    }
    
    // Migrer les employés
    if (data.employes && data.employes.length > 0) {
      for (const employe of data.employes) {
        try {
          await syncEmployes.add(employe);
          results.success++;
        } catch (error) {
          results.errors.push({ type: 'employe', item: employe, error });
        }
      }
    }
    
    // Migrer les dépenses
    if (data.depenses && data.depenses.length > 0) {
      for (const depense of data.depenses) {
        try {
          await syncDepenses.add(depense);
          results.success++;
        } catch (error) {
          results.errors.push({ type: 'depense', item: depense, error });
        }
      }
    }
    
    // Migrer les entrées
    if (data.entrees && data.entrees.length > 0) {
      for (const entree of data.entrees) {
        try {
          await syncEntrees.add(entree);
          results.success++;
        } catch (error) {
          results.errors.push({ type: 'entree', item: entree, error });
        }
      }
    }
    
    // Continuer avec les autres types de données...
    
    // Nettoyer localStorage après migration réussie
    if (results.errors.length === 0) {
      localStorage.removeItem('monarchTradeGroup');
    }
    
    return results;
  } catch (error) {
    console.error('Erreur lors de la migration:', error);
    throw error;
  }
};